import { render } from "./ResultFoot.vue?vue&type=template&id=e6a1580e&scoped=true"
import script from "./ResultFoot.vue?vue&type=script&lang=js"
export * from "./ResultFoot.vue?vue&type=script&lang=js"

import "./ResultFoot.vue?vue&type=style&index=0&id=e6a1580e&lang=scss&scoped=true"

import exportComponent from "/Users/konatsu/docker-static/speedo.devs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6a1580e"]])

export default __exports__